<style lang="scss">
// @import "../style/layout/Layout_Top_Left";
</style>

<template>
    <div  :class="rootClass">
        <div class="oms-layout" style="height: 100%;">
            <div class="oms-layout-header top-menu top-menu-size">
                <Row>
                    <i-col class="top-menu-left" :xs="4" :sm="4" :md="4" :lg="4">
                        <img class="layout-logo-img" src="../../static/image/logo.png">
                    </i-col>
                    <i-col class="top-menu-right" :xs="20" :sm="20" :md="20" :lg="20">
                        <Row>
                            <i-col span="24">
                                <div class="header-operation header-top-right">
                                    <Cascader class="header-cascader" v-model="activeLocale" :data="localeData" @on-change="handleChange">
                                        <a href="javascript:void(0)">{{locale}}</a>
                                    </Cascader>
                                    <Button type="text">
                                        <Icon type="android-person" size="12"></Icon>
                                         <span>{{userBase.displayname}}</span>
                                    </Button>
                                    <Button type="text">
                                        <Icon type="key" size="12"></Icon>
                                        <span>修改密码</span>
                                    </Button>
                                    <Button type="text" @click="$api.loginout()">
                                        <Icon type="power" size="12"></Icon>
                                        <span>退出</span>
                                    </Button>
                                </div>
                            </i-col>
                        </Row>
                        <Row>
                            <i-col span="24">
                                <Menu ref="top_menu" @on-select="headerMenuClick" mode="horizontal" class="ivu-menu-empty" :active-name="activeName">
                                    <div :class="menuTop.scrollable?'menu-top-show-scroll':''">
                                        <span :disabled="menuTop.disabledPrev" class="ivu-menu-nav-prev"  @click="menuNavPrev"><i class="ivu-icon ivu-icon-chevron-left"></i></span>
                                        <span :disabled="menuTop.disabledNext" class="ivu-menu-nav-next" @click="menuNavNext"><i class="ivu-icon ivu-icon-chevron-right" ></i></span>
                                        <div ref="navScroll" class="ivu-menu-nav-scroll" :style="menuTop.menuTotalWidth">
                                            <div ref="menuNav" class="ivu-menu-nav" :style="menuTop.menuTranslateX">
                                                <template v-for="(menuItem,index) in headerMenus">
                                                    <MenuItem :name="menuItem.id">
                                                        <span v-if="menuItem.i18nTitle">{{$t(menuItem.i18nTitle)}}</span>
                                                        <span v-else>{{menuItem.title}}</span>
                                                    </MenuItem> 
                                                </template>
                                            </div>
                                        </div>
                                    </div>  
                                </Menu>
                            </i-col>
                        </Row>
                    </i-col>
                </Row>
                
            </div>
            <div class="oms-layout">
                <div class="oms-layout oms-layout-has-sider">
                    <div class="oms-layout-sider left-menu left-menu-size">
                        <div class="oms-layout-sider-children">
                            <Menu ref="left_menu"  @on-select="leftMenuClick" :open-names="leftOpenName" :active-name="leftActiveName" class="ivu-menu-empty" width="auto" >
                                <template v-for="(menuItem,index) in leftMenus" >
                                    <Submenu :name="menuItem.id" v-if="menuItem.children&&menuItem.children.length>0">
                                        <template slot="title">
                                            <span class="ivu-menu-submenu-span">
                                                <span v-if="menuItem.i18nTitle">{{$t(menuItem.i18nTitle)}}</span>
                                                <span v-else>{{menuItem.title}}</span>
                                            </span> 
                                        </template>
                                        <template v-for="(itemC,indexC) in menuItem.children">
                                            <Submenu :name="itemC.id" v-if="itemC.children&&itemC.children.length>0">
                                                <template slot="title">
                                                    <span class="ivu-menu-submenu-span">
                                                        <span v-if="itemC.i18nTitle">{{$t(itemC.i18nTitle)}}</span>
                                                        <span v-else>{{itemC.title}}</span>
                                                    </span> 
                                                </template>
                                                <template v-for="(itemD,indexD) in itemC.children">
                                                    <MenuItem :name="itemD.id" style="padding-left: 28px;" class="ivu-menu-submenu-title">
                                                        <router-link class="left-menu-a" :to="'/' + itemD.href">
                                                            <span v-if="itemD.i18nTitle">{{$t(itemD.i18nTitle)}}</span>
                                                            <span v-else>{{itemD.title}}</span>
                                                        </router-link>
                                                    </MenuItem>
                                                </template>
                                            </Submenu>
                                            <MenuItem :name="itemC.id" style="padding: 0px;" v-else >
                                                <router-link class="ivu-menu-submenu-title left-menu-a" :to="'/' + itemC.href">
                                                    <span v-if="itemC.i18nTitle">{{$t(itemC.i18nTitle)}}</span>
                                                    <span v-else>{{itemC.title}}</span>
                                                </router-link>
                                            </MenuItem>
                                        </template>
                                    </Submenu>
                                    <MenuItem class="menu-first-item" :name="menuItem.id" v-else >
                                        <div >
                                            <router-link class="left-menu-a" :to="'/' + menuItem.href">
                                                <span v-if="menuItem.i18nTitle">{{$t(menuItem.i18nTitle)}}</span>
                                                <span v-else>{{menuItem.title}}</span>
                                            </router-link>
                                        </div>
                                    </MenuItem> 
                                </template>
                            </Menu>
                            <div class="oms-layout-footer">版权所有 荣耀软件技术有限公司</div>
                        </div>
                    </div>
                    <div class="oms-tab-layout-content">
                        <div class="oms-layout-content">
                            <div >
                                <tags-nav ref="tagsNav" :value="leftActiveName" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
                            </div>
                        </div>
                    </div>
                    <!-- <div id="omsLayoutContent" class="oms-layout-content">
                        <router-view :key="activeDate"/>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import tagsNav from './tagsNav.vue'
import { mapGetters, mapState } from 'vuex'
import iView from 'iview';
    export default {
        components:{tagsNav},
        name: 'Layout_Top_Left',
        data () {
            return {
                tagNavList :[],
                tagNavListCache:{},
                pathCache:"",
                activeDate:1,
                rootClass:"layout-top-left-bottom",
                userBase:{displayname:"xxx"},
                activeLocale:["zh-CN"],
                locale:"简体中文",
                localeData:[{ 
                    value: 'zh-CN',
                    label: '简体中文'
                    },{ 
                    value: 'en-US',
                    label: 'English'
                    }],
                menuTop:{
                    scrollable: false,
                    //头部菜单默认最大宽度,如果实际宽度大于总宽度才使用该变量
                    menuItemWidth:104,
                    menuTotalWidth:"",
                    //偏移宽度
                    menuTranslateX:"",
                    //每页个数
                    menuItemCount:"",
                    curPage:1,
                    disabledPrev:true,
                    disabledNext:true
                },
                value:true,
                activeName:"",
                //左侧栏目选中项
                leftActiveName:"",
                //左侧栏目展开项
                leftOpenName:[],
                leftOpenNameCache:{},
                //根据id缓存所有栏目
                allMenuMap:{},
                noPermAllMenuMap:{},
                //根据href缓存所有栏目
                allMenuHrefMap:{},
                //左侧栏目数据
                leftMenus:[],
                breadcrumbItem:[],
                //头部栏目数据
                headerMenus:[],
                headerMenusCache:{},
                header_menu_x:0,
                header_menu_style:"transform: translateX("+this.header_menu_x+"px);"
            }
        },
        //初始化后调用
        mounted:function(){
            this.$store.commit("base/setLayoutTabRef", {setActiveMenu:this.setActiveMenu});
            this.initMenu()
        },
        methods:{
            initMenu(){
                this.removeTheme()
                this.userBase=this.$store.state.userInfo.userBase
                // Object.assign(userBase,stateUserBase);

                //设置语言下拉选中的值
                var self=this,activeLocale=this.$i18n.locale;
                this.activeLocale=[activeLocale];
                this.localeData.forEach(element => {
                    if(element.value===activeLocale){
                        self.locale=element.label;
                        return element.label;
                    }
                });
                //设置菜单数据
                this.setAllMenuMap();
                this.headerMenus=this.setAllMenu()
                this.noPermAllMenuMap=this.allMenuMap
                this.allMenuMap=this.headerMenusCache
                let path=this.$route.path;
                if(path!="/"){
                    this.setNodeSelected(path);
                }
                // else{
                //     this.activeName="001";
                //     this.setLeftMenus("001");
                // }
            },
            removeTheme(){
                //更换菜单的主题样式
                let eList=this.$el.getElementsByClassName("ivu-menu-light")
                this.$utils.dom.removeListClass(eList,"ivu-menu-light")
            },
            //语言切换
            handleChange (value, selectedData) {
                const locale= this.$i18n.locale=value[0];
                this.locale = selectedData.map(o => o.label).join(',');
                iView.locale=locale;
                //改变vuex中的值
                this.$store.commit("userInfo/setUserInfoLocale",locale);
                //重新加载组件，即相当于刷新了页面
                this.reload();
            },
            //路由重新加载组件
            reload () {
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            },
            //根据url选中菜单
            setNodeSelected(p,t){
                let path=p||this.$route.path;
                let self=this
                if(path!="/"){
                    let href=path.replace("/","");
                    //从缓存中获取菜单数据
                    let menu=this.allMenuHrefMap[href];
                    if(!menu){return false;}
                    //根据名称获取头部栏目
                    let toMenuId=this.getTopMenu(menu.pid);
                    //选中头菜单,如果p为-1说明是点击头部菜单
                    if(t!="-1")this.activeName=toMenuId;
                    this.leftMenus.length>0||this.setLeftMenus(toMenuId);
                    this.setLeftOpenName(this.allMenuMap[menu.pid])
                    //如果是第四级，需要在判断父节点是否有父节点
                    if(this.allMenuMap[menu.pid].pid!="-1"){this.setLeftOpenName(this.allMenuMap[this.allMenuMap[menu.pid].pid]);}
                    this.leftActiveName=menu.id;
                    this.$nextTick(() => {
                        self.setScrollableShow()
                        self.$refs.top_menu.updateActiveName();
                        self.$refs.left_menu.updateOpened();
                        self.$refs.left_menu.updateActiveName();
                        self.leftMenuClick(menu.id);
                    })
                }
            },
            //设置左侧菜单展开
            setLeftOpenName(menu){
                if(!this.leftOpenNameCache[menu.id]){
                    this.leftOpenNameCache[menu.id]=menu
                    this.leftOpenName.push(menu.id)
                }
            },
            addTagNavList(menu){
                let self=this
                if(!(menu.children&&menu.children.length>0)||menu.type=='topMenu'){
                    //tabs添加数据
                    if(!self.tagNavListCache[menu.name]){
                        self.tagNavListCache[menu.name]=menu
                        self.tagNavList.push(menu)
                    }else{
                        menu._activeDate=new Date().getTime()
                    }
                }
            },
            //根据名称获取头部栏目
            getTopMenu:function(id){
                let topMenuId=this.allMenuMap[id];
                if(topMenuId.pid!="-1"){
                  return  this.getTopMenu(topMenuId.pid);
                }
                return topMenuId.id;
            },
            //根据id获取所有父节点，比如给面包屑用
            getAllPNodeById:function(pid){
                let node=this.allMenuMap[pid];
                let pNodes=[];
                if(node.pid!="-1"){
                    let p=this.getAllPNodeById(node.pid);
                    pNodes=pNodes.concat(p);
                    pNodes.push(node);
                }else{
                    pNodes.push(node);
                }
                return pNodes;
            },
            //设置头部菜单滑动按钮是否出现
            setScrollableShow(){
                //头部菜单显示总宽度
                const menuTotalWidth=this.$refs.navScroll.offsetWidth
                //头部菜单实际宽度
                const menuWidth=this.$refs.menuNav.offsetWidth
                if(menuTotalWidth-menuWidth<0){
                    this.menuTop.scrollable=true
                    this.menuTop.disabledNext=false
                }
                if(menuWidth>210){
                    const menuItemWidth=this.menuTop.menuItemWidth
                    const itemCount=this.menuTop.menuItemCount=parseInt(menuTotalWidth/menuItemWidth)
                    //修改显示的总宽度
                    this.menuTop.menuTotalWidth="width:"+menuItemWidth*itemCount+"px;"
                }
            },
            //设置滑动按钮左边点击事件
            menuNavPrev() {
                if(!this.menuTop.disabledPrev){
                    if(this.menuTop.curPage!=1)this.menuTop.curPage--
                    this.setOffset()
                }
            },
            //设置滑动按钮右边点击事件
            menuNavNext() {
                if(!this.menuTop.disabledNext){
                    this.menuTop.curPage++
                    this.setOffset()
                }
            },
            //设置菜单偏移量
            setOffset(){
                //头部菜单显示总宽度
                const menuTotalWidth=this.$refs.navScroll.offsetWidth
                //头部菜单实际宽度
                const menuWidth=this.$refs.menuNav.offsetWidth
                if(menuTotalWidth-menuWidth<0){
                    this.menuTop.scrollable=true
                }
                if(menuWidth>210){
                    const menuItemWidth=this.menuTop.menuItemWidth
                    const itemCount=this.menuTop.menuItemCount=parseInt(menuTotalWidth/menuItemWidth)
                    //修改显示的总宽度
                    this.menuTop.menuTotalWidth="width:"+menuItemWidth*itemCount+"px;"
                    const wr=menuItemWidth*itemCount*this.menuTop.curPage
                    const w=menuItemWidth*itemCount*(this.menuTop.curPage-1)
                    if(w>=0&&menuWidth>w){
                        this.menuTop.disabledPrev=false
                        this.menuTop.disabledNext=false
                        this.menuTop.menuTranslateX="transform: translateX(-"+w+"px);"
                    }
                    if(w==0){
                        this.menuTop.disabledPrev=true
                    }
                    if(menuWidth<=wr){
                        this.menuTop.disabledNext=true
                    }
                }
            },
            //设置栏目缓存数据
            setAllMenuMap(datas){
                var self=this,
                am=this.allMenuMap,
                hmc=this.headerMenusCache,
                amh=this.allMenuHrefMap,
                datas=datas||this.$store.state.menu.headerMenus;
                for(let i=0;i<datas.length;i++){
                     let m=datas[i];
                     am[m.id]=m;
                     amh[m.href]=m;
                     hmc[m.id]=self.$utils.deepCopy(m);
                     delete hmc[m.id].children;
                     if(m.children&&m.children.length>0){
                         self.setAllMenuMap(m.children);
                     }
                 }
            },
            //设置菜单栏，带权限过滤
            setAllMenu(){
                let self=this,
                menuCache=this.headerMenusCache||{},
                menuRoot=[];
                for(let i in menuCache){
                    let m=menuCache[i],
                    permStr=m.perm;
                    if(!permStr||(permStr&&this.$perm(permStr))){
                        if(m.pid=="-1"){
                            menuRoot.push(m)
                        }else{
                            if(!menuCache[m.pid].children)menuCache[m.pid].children=[]
                            menuCache[m.pid].children.push(m)
                        } 
                        
                    }
                }
                return menuRoot;
            },
            setLeftMenus(seId){
                let self=this
                let leftMenus=this.allMenuMap[seId];
                leftMenus=leftMenus&&leftMenus.children||[];
                this.leftMenus=leftMenus
                // this.leftOpenName=[];
                for(let i=0;i<leftMenus.length;i++){
                    if(leftMenus[i].children&&leftMenus[i].children.length>0){
                        this.setLeftOpenName(leftMenus[i])
                    }
                }
                this.$nextTick(()=>{self.removeTheme();self.$refs.left_menu.updateOpened();})
            },
            headerMenuClick:function(seId){
                this.$router.push({path:"/"})
                this.setNodeSelected(null,-1);
                this.setLeftMenus(seId);
                // this.breadcrumbItem=[];
                // this.breadcrumbItem.push(leftMenus);
            }, 
            // leftMenuClick(seId){
            //     let self=this,menu= this.allMenuMap[seId]||"";
            //     if((!menu.children||menu.children.length===0)&&menu.href){
            //        // this.$router.push(menu.href);
            //     }
            //     let permStr=menu.perm;
            //     if(!permStr||(permStr&&this.$perm(permStr))){
            //         //获取所有父节点
            //         const ms=this.getAllPNodeById(menu.pid);
            //         ms.push(menu);
            //         //给面包屑数据重新赋值
            //         this.breadcrumbItem=ms;
            //         this.leftActiveName=menu.name
            //         //如果地址没变，也刷新页面
            //         let path=this.$route.path;
            //         if(path==this.pathCache){
            //             this.activeDate = new Date().getTime()
            //         }
            //         this.pathCache=path
            //     }else{
            //         this.$utils.tips.noPremGoHome()
            //         setTimeout(function(){
            //             self.$router.push({ name: "home"});
            //             self.setNodeSelected(null,-1);
            //         },2000)
            //     }
            // }

            leftMenuClick(seId){
                let self=this,menu= this.allMenuMap[seId]||"";
                if(this.isSetActiveMenuF==2&&this.isSetActiveMenu){
                    this.isSetActiveMenu=false
                    return false
                }else{
                   this.isSetActiveMenuF++ 
                }
                if((!menu.children||menu.children.length===0)&&menu.href){
                   // this.$router.push(menu.href);
                }
                let permStr=menu.perm;
                if(!permStr||(permStr&&this.$perm(permStr))){
                    //获取所有父节点
                    const ms=this.getAllPNodeById(menu.pid);
                    ms.push(menu);
                    //给面包屑数据重新赋值
                    this.breadcrumbItem=ms;
                    this.leftActiveName=menu.name
                    //tabs添加数据
                    this.addTagNavList(menu)
                }else{
                    this.$utils.tips.noPremGoHome()
                    setTimeout(function(){
                        self.$store.commit("base/setLayoutName","home")
                        self.$router.push({ name: "home"});
                        self.setNodeSelected(null,-1);
                    },2000)
                }
            },
            turnToPage (name) {
                this.$router.push({
                    name: name
                })
            },
            handleCollapsedChange (state) {
                // this.collapsed = state
            },
            handleCloseTag (res, type, name) {
                const nextName = this.getNextName(this.tagNavList, name)
                this.tagNavList=res
                delete this.tagNavListCache[name]
                if (type === 'all') {
                    this.tagNavList=[]
                    this.tagNavListCache={}
                    this.leftActiveName=""
                }else if (type === 'others') {
                    this.tagNavListCache={}
                    this.tagNavListCache[res[0].name]=res[0]
                }else if(this.leftActiveName==name){
                    this.leftActiveName=nextName
                }
            },
            /**
             * @param {Array} list 标签列表
             * @param {String} name 当前关闭的标签的name
             */
            getNextName(list, name){
                let res = ''
                if(list.length>1){
                    if (list.findIndex(item => item.name === name) === list.length - 1){
                        res = list[list.length - 2].name
                    }else {
                        res = list[list.findIndex(item => item.name === name) + 1].name
                    }
                }
                return res
            },
            handleClick (item) {
                this.leftActiveName=item.name
                // this.leftMenuClick(item.id)
                // item._activeDate=new Date().getTime()
            },
            setActiveMenu(to){
                let path=to.path;
                let menu=this.allMenuHrefMap[path]
                this.pathCache=path
                if(path!="/"){
                    this.isSetActiveMenu=true
                    this.isSetActiveMenuF=1
                    this.setNodeSelected(path);
                }else if(menu){
                    this.setLeftMenus(menu.id);
                }
            }
            

        }
    }
</script>



// WEBPACK FOOTER //
// src/layout/Layout_top_tab.vue